/**
 * @file 文档页页面路由
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import PaddleLabDownload from './pages/download/PaddlexDownload';
import UserInfo from './pages/user-info/UserInfo';
import PaddlexReleaseNote from './pages/release-note/PaddlexReleaseNote';
import PaddlexHistory from './pages/history/PaddlexHistory';

const PaddlexRoute = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/paddlex/download" component={PaddleLabDownload} />
                <Route path="/paddlex/userinfo" component={UserInfo} />
                <Route path="/paddlex/releasenote" component={PaddlexReleaseNote} />
                <Route path="/paddlex/history" component={PaddlexHistory} />
                <Redirect to="/paddlex/download" />
            </Switch>
        </BrowserRouter>
    );
};

export default PaddlexRoute;
